(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slim-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalizePath = (path) => {
      try {
        const url = new URL(path, window.location.origin);
        return decodeURIComponent(url.pathname).replace(/\/+$/, '').toLowerCase();
      } catch (error) {
        return '';
      }
    };

    const syncSlimCarousels = () => {
      const currentPath = normalizePath(window.location.pathname);

      for (const track of document.querySelectorAll('.slim-collection-carousel__track')) {
        let activeItem = null;

        for (const item of track.querySelectorAll('.slim-collection-carousel__item')) {
          const link = item.querySelector('.slim-collection-carousel__link');
          const href = link?.getAttribute('href');
          const isActive = Boolean(currentPath) && Boolean(href) && normalizePath(href) === currentPath;

          item.classList.toggle('is-active', isActive);

          if (link) {
            link.classList.toggle('slim-collection-carousel__link--active', isActive);
            if (isActive) {
              link.setAttribute('aria-current', 'page');
            } else {
              link.removeAttribute('aria-current');
            }
          }

          if (isActive) {
            activeItem = item;
          }
        }

        if (!activeItem) {
          continue;
        }

        const trackRect = track.getBoundingClientRect();
        const itemRect = activeItem.getBoundingClientRect();
        const isVisible = itemRect.left >= trackRect.left && itemRect.right <= trackRect.right;

        if (!isVisible) {
          activeItem.scrollIntoView({ inline: 'center', block: 'nearest' });
        }
      }
    };

    syncSlimCarousels();
    requestAnimationFrame(syncSlimCarousels);
    document.addEventListener('shopify:section:load', syncSlimCarousels);
    window.addEventListener('pageshow', syncSlimCarousels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-contact"] && !Shopify.designMode) return;
  try {
    
  const inquiryContent = {
    buying: {
      messagePlaceholder: 'Tell us your target brand, model, ideal condition, and budget range.',
      messageTooltip: 'Include preferred condition, region, and timeline so we can source efficiently.'
    },
    selling: {
      messagePlaceholder: 'Share condition, service history, and expected price guidance.',
      messageTooltip: 'Please include ownership details, condition notes, and any recent servicing.'
    },
    other: {
      messagePlaceholder: 'Let us know how we can support your request.',
      messageTooltip: 'Use this option for partnerships, concierge support, events, or general questions.'
    }
  };

  const getNormalizedInquiryType = (value) => {
    if (value === 'buying' || value === 'selling' || value === 'other') return value;
    return 'buying';
  };

  const closeOpenInfoPanels = (scope) => {
    const infoPanels = scope.querySelectorAll('[data-info].is-open');
    for (const panel of infoPanels) {
      panel.classList.remove('is-open');
      const trigger = panel.querySelector('[data-info-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  };

  const initializeStoryContactInquiry = (form) => {
    if (!form || form.dataset.inquiryInitialized === 'true') return;

    const inquirySelect = form.querySelector('[data-inquiry-type]');
    const messageInput = form.querySelector('[data-inquiry-message]');
    const messageTooltip = form.querySelector('[data-message-tooltip]');
    if (!inquirySelect || !messageInput || !messageTooltip) return;

    const applyInquiryState = () => {
      const selectedInquiry = getNormalizedInquiryType(inquirySelect.value);

      const currentGroup = form.querySelector('[data-inquiry-group]:not([hidden])');
      const carryBrand = currentGroup?.querySelector('[name="contact[brand]"]')?.value ?? '';
      const carryModel = currentGroup?.querySelector('[name="contact[model]"]')?.value ?? '';

      const fieldGroups = form.querySelectorAll('[data-inquiry-group]');
      for (const group of fieldGroups) {
        const isActiveGroup = group.dataset.inquiryGroup === selectedInquiry;
        group.hidden = !isActiveGroup;

        const controls = group.querySelectorAll('[data-inquiry-control]');
        for (const control of controls) {
          control.disabled = !isActiveGroup;
        }

        if (isActiveGroup && currentGroup && currentGroup !== group) {
          const brandInput = group.querySelector('[name="contact[brand]"]');
          const modelInput = group.querySelector('[name="contact[model]"]');
          if (brandInput && carryBrand) brandInput.value = carryBrand;
          if (modelInput && carryModel) modelInput.value = carryModel;
        }
      }

      messageInput.setAttribute('placeholder', inquiryContent[selectedInquiry].messagePlaceholder);
      messageTooltip.textContent = inquiryContent[selectedInquiry].messageTooltip;
      closeOpenInfoPanels(form);
    };

    inquirySelect.addEventListener('change', applyInquiryState);
    applyInquiryState();

    const infoPanels = form.querySelectorAll('[data-info]');
    for (const panel of infoPanels) {
      const trigger = panel.querySelector('[data-info-trigger]');
      if (!trigger) continue;

      trigger.addEventListener('click', (event) => {
        const useClickBehavior = window.matchMedia('(hover: none), (pointer: coarse)').matches;
        if (!useClickBehavior) return;

        event.preventDefault();
        const shouldOpen = !panel.classList.contains('is-open');
        closeOpenInfoPanels(form);
        if (shouldOpen) {
          panel.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    }

    document.addEventListener('click', (event) => {
      const useClickBehavior = window.matchMedia('(hover: none), (pointer: coarse)').matches;
      if (!useClickBehavior) return;
      if (form.contains(event.target) && event.target.closest('[data-info]')) return;
      closeOpenInfoPanels(form);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeOpenInfoPanels(form);
    });

    form.dataset.inquiryInitialized = 'true';
  };

  // Our own webhook. It forwards the submission as email through the Gmail API.
  // The key only stops a bot that guessed the path: this page shows it to every
  // visitor. The server rejects a payload without it.
  const MAIL_WEBHOOK_URL = 'https://automations.timeandwine.com/w/d6be20f46bd133bde9cc919ef80fb622';
  const MAIL_WEBHOOK_KEY = 'Npw3KTwBEhWTv9JaINn1-b1ppQxFf-Eb';

  const CONTACT_FIELD_PATTERN = /^contact\[(.+)\]$/;
  // 0/O and 1/I are absent so a visitor can read a reference back to us without ambiguity.
  const REFERENCE_ALPHABET = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
  const REFERENCE_LENGTH = 6;

  const sessionKey = (form, suffix) => 'story-contact-' + suffix + '-' + (form.id || 'default');

  const readSession = (key) => {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const writeSession = (key, value) => {
    try {
      if (value === null) {
        sessionStorage.removeItem(key);
      } else {
        sessionStorage.setItem(key, value);
      }
    } catch (error) {
      /* sessionStorage unavailable (e.g. private mode) — degrade gracefully */
    }
  };

  const createReference = () => {
    const values = new Uint8Array(REFERENCE_LENGTH);

    if (window.crypto?.getRandomValues) {
      window.crypto.getRandomValues(values);
    } else {
      for (let index = 0; index < REFERENCE_LENGTH; index += 1) {
        values[index] = Math.floor(Math.random() * 256);
      }
    }

    let code = '';
    for (const value of values) {
      code += REFERENCE_ALPHABET[value % REFERENCE_ALPHABET.length];
    }

    return 'AZ-' + code;
  };

  const buildWebhookPayload = (form, reference) => {
    const payload = {};

    for (const [rawName, rawValue] of new FormData(form).entries()) {
      if (typeof rawValue !== 'string') continue;

      const match = CONTACT_FIELD_PATTERN.exec(rawName);
      if (!match) continue;

      const name = match[1];
      if (name === 'id') continue;

      payload[name] = rawValue.trim();
    }

    // Inactive inquiry groups are disabled, so their fields never reach FormData.
    // Only the selling flow shows the checkbox, so only there is "No" meaningful.
    if (payload.inquiry_type === 'selling') {
      payload.box_and_papers = payload.box_and_papers ? 'Yes' : 'No';
    }

    payload.reference = reference;
    payload.source = 'story-contact';
    payload.submitted_at = new Date().toISOString();
    payload.page_url = window.location.href;
    payload.page_title = document.title;
    payload.shop_domain = window.Shopify?.shop || window.location.host;

    return payload;
  };

  // This runs while the browser is already navigating away, so the request must
  // outlive the page. sendBeacon is built for that; a keepalive fetch covers
  // browsers that refuse the beacon. A text/plain body avoids a CORS preflight,
  // which sendBeacon cannot perform.
  //
  // The server sends the email and posts the Discord message. Neither the
  // Discord URL nor any other secret belongs in this file: the page source is
  // public.
  const sendToMailWebhook = (payload) => {
    // A copy, so the key stays out of the payload the caller passed in.
    const body = JSON.stringify({ ...payload, key: MAIL_WEBHOOK_KEY });
    const contentType = 'text/plain;charset=UTF-8';

    try {
      if (navigator.sendBeacon?.(MAIL_WEBHOOK_URL, new Blob([body], { type: contentType }))) {
        return;
      }
    } catch (error) {
      /* fall through to fetch */
    }

    fetch(MAIL_WEBHOOK_URL, {
      method: 'POST',
      mode: 'no-cors',
      keepalive: true,
      headers: { 'Content-Type': contentType },
      body
    }).catch(() => {
      /* Shopify's notification email stays the record of the submission */
    });
  };

  const setSubmitPending = (form, pending) => {
    const submitButton = form.querySelector('[data-story-submit]');
    if (!submitButton) return;

    submitButton.classList.toggle('is-pending', pending);
    submitButton.disabled = pending;

    if (pending) {
      submitButton.setAttribute('aria-busy', 'true');
    } else {
      submitButton.removeAttribute('aria-busy');
    }
  };

  const initializeStoryContactWebhook = (form) => {
    if (!form || form.dataset.webhookInitialized === 'true') return;

    // The submit event only fires once the browser's own validation passes.
    form.addEventListener('submit', () => {
      const reference = createReference();

      // Written before the browser serialises the form, so Shopify's notification
      // email carries the same reference as the webhook payload.
      const referenceInput = form.querySelector('[data-story-reference-input]');
      if (referenceInput) referenceInput.value = reference;

      const visitorName = form.querySelector('[name="contact[name]"]')?.value.trim() ?? '';
      writeSession(sessionKey(form, 'reference'), reference);
      writeSession(sessionKey(form, 'name'), visitorName.slice(0, 60));

      // A throw here must still leave the button to recover.
      try {
        sendToMailWebhook(buildWebhookPayload(form, reference));
      } catch (error) {
        /* Shopify's notification email stays the record of the submission */
      }

      setSubmitPending(form, true);
    });

    // Restores the button when a visitor arrives back through the browser cache.
    window.addEventListener('pageshow', () => setSubmitPending(form, false));

    form.dataset.webhookInitialized = 'true';
  };

  const hydrateThankYou = (form, thankYou) => {
    const nameTarget = thankYou.querySelector('[data-story-name]');
    if (nameTarget) {
      const storedName = readSession(sessionKey(form, 'name')) || '';
      const firstName = storedName.trim().split(/\s+/)[0] || '';
      nameTarget.textContent = firstName ? ', ' + firstName + '.' : '.';
    }

    const referenceRow = thankYou.querySelector('[data-story-reference]');
    const referenceValue = thankYou.querySelector('[data-story-reference-value]');
    const storedReference = readSession(sessionKey(form, 'reference'));

    if (referenceRow && referenceValue && storedReference) {
      referenceValue.textContent = storedReference;
      referenceRow.hidden = false;
    }
  };

  // Shopify's redirect anchors to the form element, which can leave the message under a
  // sticky header. Centre it instead so the visitor lands on the confirmation.
  const scrollThankYouIntoView = (thankYou) => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    requestAnimationFrame(() => {
      thankYou.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'center'
      });
    });
  };

  const applyStoryContactSession = (form) => {
    if (!form || form.dataset.sessionInitialized === 'true') return;

    const thankYou = form.querySelector('[data-story-thankyou]');
    const fields = form.querySelector('[data-story-fields]');
    if (!thankYou || !fields) return;

    const submittedKey = sessionKey(form, 'submitted');

    // `thankYou.hidden === false` means the server just rendered a successful
    // submission; remember it so the form stays hidden for the rest of the session.
    if (!thankYou.hidden) {
      writeSession(submittedKey, '1');
      hydrateThankYou(form, thankYou);
      scrollThankYouIntoView(thankYou);
    } else if (readSession(submittedKey) === '1') {
      thankYou.hidden = false;
      fields.hidden = true;
      hydrateThankYou(form, thankYou);
    }

    const resetLink = thankYou.querySelector('[data-story-reset]');
    if (resetLink) {
      resetLink.addEventListener('click', () => {
        writeSession(submittedKey, null);
        writeSession(sessionKey(form, 'reference'), null);
        writeSession(sessionKey(form, 'name'), null);
      });
    }

    form.dataset.sessionInitialized = 'true';
  };

  const initializeStoryContactForms = () => {
    const storyContactForms = document.querySelectorAll('.story-contact__form');
    for (const form of storyContactForms) {
      initializeStoryContactInquiry(form);
      initializeStoryContactWebhook(form);
      applyStoryContactSession(form);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeStoryContactForms, { once: true });
  } else {
    initializeStoryContactForms();
  }

  document.addEventListener('shopify:section:load', initializeStoryContactForms);

  const prefillFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('inquiry') && !params.has('message')) return;

    // URLSearchParams decodes each value already, so none of these need a second decode.
    const inquiry = params.get('inquiry');
    const brand = params.get('brand');
    const model = params.get('model');
    const message = params.get('message');

    const forms = document.querySelectorAll('.story-contact__form');
    for (const form of forms) {
      const inquirySelect = form.querySelector('[data-inquiry-type]');
      if (!inquirySelect) continue;

      if (inquiry) {
        inquirySelect.value = getNormalizedInquiryType(inquiry);
        inquirySelect.dispatchEvent(new Event('change'));
      }

      const activeGroup = getNormalizedInquiryType(inquirySelect.value);

      if (brand) {
        const brandInput = form.querySelector(`[data-inquiry-group="${activeGroup}"] [name="contact[brand]"]`);
        if (brandInput) brandInput.value = brand;
      }

      if (model) {
        const modelInput = form.querySelector(`[data-inquiry-group="${activeGroup}"] [name="contact[model]"]`);
        if (modelInput) modelInput.value = model;
      }

      // Set after the change event, so applyInquiryState cannot overwrite the field.
      if (message) {
        const messageInput = form.querySelector('[data-inquiry-message]');
        if (messageInput) messageInput.value = message;
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prefillFromUrl, { once: true });
  } else {
    prefillFromUrl();
  }

  } catch(e) { console.error(e); }
})();
})();
